<template>
	<div class="text-test-position-container">
		<p class="test-name font-italic font-weight-light">{{ testBank.name }} - {{ testBank.level }}</p>
		<div class="title-test-position">
			<h1>Bonjour {{ user.first_name }}, tu as <span class="underlineText">déjà fait</span> ce test</h1>
		</div>
		<div class="content-block">
			<div class="text-box">Ton meilleur score : {{ getHighestTestScore() }}%</div>
			<br />
			<div class="alert-block">
				<span>🚨 Nombre de tentatives épuisés, tu ne peux plus refaire ce test. </span>
			</div>
		</div>
		<div class="ortho-next-button">Non disponible</div>
	</div>
</template>

<script>
export default {
	name: 'OutOfAttempt',
	props: {
		user: Object,
		testBank: Object,
		testScores: Array,
	},

	methods: {
		getHighestTestScore() {
			if (!this.testScores || this.testScores.length === 0) return;
			const cloneTestScores = [...this.testScores];
			cloneTestScores.sort((a, b) => b.score - a.score);
			return cloneTestScores[0].score;
		},
	},
};
</script>

<style scoped lang="scss">
.test-name {
	font-size: 18px;
}
.content-block {
	margin-top: 20px;
	font-size: 20px;
}
.ortho-next-button {
	margin-bottom: 12%;
	background-color: #dddddd;
	border-color: #dddddd;
	cursor: default;
}

.title-test-position {
	font-weight: 900;
	line-height: 1.1;
	font-size: 35px;
}

.text-test-position-container {
	text-align: left;
}

.text-box {
	background-color: white;
	padding: 5px 10px;
	width: fit-content;
	border-radius: 5px;
	margin-top: 20px;
	margin-bottom: 10px;
}

.alert-block {
	line-height: 18px;
	span {
		font-size: 15px;
	}
	.alert-icon {
		font-size: 15px;
	}
}

@media only screen and (max-width: 1300px) {
	.image-test-position-container {
		right: -20%;
	}
}

@media only screen and (max-width: 600px) {
	.content-block {
		margin-top: 20px;
		font-size: 18px;

		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.full-container {
		position: relative;
	}
	.text-test-position-container {
		text-align: center;
		padding-left: 0px;
		padding-right: 0px;
	}
	.title-test-position {
		font-size: 20px;
	}
	.image-test-position {
		display: none;
	}
}
</style>
